import { ApiService } from './../../shared/ApiService/api.service';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageService } from '../storage.service';



@Injectable({
  providedIn: 'root'
})
export class UserService {
  private onLoginStateChange: any[] = [];
  userCredentials: { email: string, password: string } = { email: '', password: '' };
  authme: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private apiService: ApiService, private router: Router, private storageService: StorageService) { }


  login(data?): Observable<any> {
    const LoginUrl = environment.base_url + '/auth/login';
    return this.apiService.post(LoginUrl, data);
  }
  numberVerification(data?): Observable<any> {
    const verificationUrl = environment.base_url + '/auth/two-step-verification-mobile';
    return this.apiService.post(verificationUrl, data);
  }
  otpVerification(data?): Observable<any> {
    const verificationUrl = environment.base_url + '/auth/two-step-verification';
    return this.apiService.post(verificationUrl, data);
  }
  reSendOTP(data?): Observable<any> {
    const verificationUrl = environment.base_url + '/auth/resend-two-step-otp';
    return this.apiService.post(verificationUrl, data);
  }
  reSendOTPPmnam(data?): Observable<any> {
    const verificationUrl = environment.base_url + '/apprenticeship-mela/resend-otp';
    return this.apiService.post(verificationUrl, data);
  }

  emailVerification(data?): Observable<any> {
    const verificationUrl = environment.base_url + '/auth/login-get-otp';
    return this.apiService.post(verificationUrl, data);
  }
  sendActivationLink(data?): Observable<any> {
    const verificationUrl = environment.base_url + '/auth/request-update-mobile';
    return this.apiService.post(verificationUrl, data);
  }
  otpLogin(data?): Observable<any> {
    const verificationUrl = environment.base_url + '/auth/login-otp';
    return this.apiService.post(verificationUrl, data);
  }
  otpRegister(data?): Observable<any> {
    const verificationUrl = environment.base_url + '/auth/register-otp';
    return this.apiService.post(verificationUrl, data);
  }
  validateCaptcha(captcha) {
    const url = `${environment.base_url}/recaptcha/${captcha}`;
    return this.apiService.get(url);
}

  candidateRegister(data?): Observable<any> {
    const verificationUrl = environment.base_url + '/auth/register-get-otp';
    return this.apiService.post(verificationUrl, data);
  }

  apprenticeServices(apprentice_registration_number?:any,dob?:any): Observable<any> {
    const certificateurl = `${environment.base_url}/dgt/marksheet-certificate?apprentice_registration_number=${apprentice_registration_number}&dob=${dob}`;
    return this.apiService.get(certificateurl);
  }
  downloadOTMarkCertbyContractCode(searchtype, contractCode, dob): Observable<any> {
    const certificateurl = `${environment.base_url}/ot/marksheet-certificate?search_type=${searchtype}&contract_code=${contractCode}&dob=${dob}`;
    return this.apiService.get(certificateurl)
  }
   downloadOTMarkCertbyApprentice(searchtype, apprenticeData, fatherName, dob): Observable<any> {
    const certificateurl = `${environment.base_url}/ot/marksheet-certificate?search_type=${searchtype}&apprentice_name=${apprenticeData}&father_name=${fatherName}&dob=${dob}`;
    return this.apiService.get(certificateurl)
  }
  downloadLegacyCert(apprenticeData, fatherName, dob): Observable<any> {
    const certificateurl = `${environment.base_url}/fetch-trainee?apprentice_name=${apprenticeData}&father_name=${fatherName}&date_of_birth=${dob}`;
    return this.apiService.get(certificateurl)
  }
  downloadLegacyCertMark(apprenticeData, fatherName, dob): Observable<any> {
    const certificateurl = `${environment.base_url}/dgt/legacy/marksheet-certificate?candidate_name=${apprenticeData}&father_name=${fatherName}&date_of_birth=${dob}`;
    return this.apiService.get(certificateurl)
  }

  // candiadteBankDetails(id: any, data?: any) {
  //   const bankDetails = `${environment.base_url}/candidates/${id}/update-bank-account`;
  //   return this.apiService.post(bankDetails, data);
  // }
  candidateRegisterPmnam(data?): Observable<any> {
    const verificationUrl = environment.base_url + '/apprenticeship-mela/register-get-otp';
    return this.apiService.post(verificationUrl, data);
  }

  logOut(): Observable<any> {
    const url = `${environment.base_url + '/auth/logout'}`;
    return this.apiService.post(url);
  }

  changePassword(data?): Observable<any> {
    const changePasswordUrl = environment.base_url + '/auth/change-password';
    return this.apiService.post(changePasswordUrl, data);
  }
  signUp(data?): Observable<any> {
    const signUpUrl = environment.base_url + '/auth/register';
    return this.apiService.post(signUpUrl, data);
  }
  candidateReg(data?): Observable<any> {
    const signUpUrl = environment.base_url + '/auth/candidates';
    return this.apiService.post(signUpUrl, data);
  }
  CheckCandidateDetail(data?): Observable<any> {
    const signUpUrl = environment.base_url + '/apprenticeship-mela/account-verify';
    return this.apiService.post(signUpUrl, data);
  }
  melaRegistration(data?){
    const signUpUrl = environment.base_url + '/apprenticeship-mela';
    return this.apiService.post(signUpUrl, data);
  }
  forgotPassword(data: any): Observable<any> {
    const forgotPasswordUrl = environment.base_url + '/auth/forgot-password';
    return this.apiService.post(forgotPasswordUrl, data);
  }
  runOnUserLoginChange(fn: any) {
    if (typeof fn === 'function') {
      this.onLoginStateChange.push(fn);
    }
  }
  cardaData(){
    const financialYear = this.getfinancialYear()
    const url = environment.base_url + `/naps-kpi-cards/?financial_years=0&financial_year=FY-${financialYear}`
    return this.apiService.get(url);

  }
  getfinancialYear(){
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const startYear = month >= 4 ? year : year - 1;
    const endYear = startYear + 1;
    const startYearShort = startYear.toString().slice(-2);
    const endYearShort = endYear.toString().slice(-2);
    return `${startYearShort}-${endYearShort}`;
  }
  patchNCVTdataOnSearch(search_data : any): Observable<any> {
    const listNCVTurl = `${environment.base_url + '/auth/get-candidate-details-from-ncvt'}`;
    return this.apiService.post(listNCVTurl,search_data);
  }

  onUserLoginStateChange() {
    for (const fn of this.onLoginStateChange) {
      if (typeof fn === 'function') {
        fn();
      }
    }
  }

  setPassword(data: any): Observable<any> {
    const setPasswordUrl = environment.base_url + '/auth/set-password';
    return this.apiService.post(setPasswordUrl, data);
  }
  resendLink(data: any): Observable<any> {
    const resendLinkUrl = environment.base_url + '/auth/resend-activation';
    return this.apiService.post(resendLinkUrl, data);
  }
  sendMobileOTP(data: any): Observable<any> {
    const resendLinkUrl = environment.base_url + '/auth/update-mobile-get-otp';
    return this.apiService.post(resendLinkUrl, data);
  }
  ReSendMobileOTP(data: any): Observable<any> {
    const resendLinkUrl = environment.base_url + '/auth/resend-two-step-otp';
    return this.apiService.post(resendLinkUrl, data);
  }
  validateMobileOTP(data: any): Observable<any> {
    const resendLinkUrl = environment.base_url + '/auth/update-mobile-otp';
    return this.apiService.post(resendLinkUrl, data);
  }
  getLoggedInuserDetails(): Observable<any> {
    const getLoggedInuserDetailsBaseUrl = `${environment.base_url + '/auth/me'}`;
    return this.apiService.post(getLoggedInuserDetailsBaseUrl).pipe(map(res => {
      this.setLoggedInuserDetails(res);
    }, err => {
      if (err.status === 401) {
        this.logOut().subscribe(() => {
          this.storageService.removeData('access_token');
          this.router.navigate(['/login']);
          this.onUserLoginStateChange();
        });
      }
    }));
  }

  getLoggedInuserDetailsForHeader(): Observable<any> {
    const getLoggedInuserDetailsBaseUrl = `${environment.base_url + '/auth/me'}`;
    return this.apiService.post(getLoggedInuserDetailsBaseUrl);
  }

  activateUser(id: any, token: any): Observable<any> {
    const _headers = new HttpHeaders();
    const headers = _headers.append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer' + token);
    const activateUserurl = environment.base_url + '/auth/activate/' + id + '/' + token;
    return this.apiService.get(activateUserurl, { headers });
  }

  getHomepageStats(): Observable<any> {
    const statsUrl = `${environment.base_url}/homepage-stats`;
    return this.apiService.get(statsUrl);
  }
  
  geteKycMapData(): Observable<any> {
    const statsUrl = `${environment.base_url}/home/ekyc-map`;
    return this.apiService.get(statsUrl);
  }
  geteKycNumberData(): Observable<any> {
    const statsUrl = `${environment.base_url}/home/apprentice-statics`;
    return this.apiService.get(statsUrl);
  }

  activateEmail(id: any, token: any): Observable<any> {
    const _headers = new HttpHeaders();
    const headers = _headers.append('Content-Type', 'application/json')
      .append('Authorization', 'Bearer' + token);
    const activateUserurl = environment.base_url + '/auth/activate-email/' + id + '/' + token;
    return this.apiService.get(activateUserurl, { headers });
  }

  getLoggedInUser(): Observable<any> {
    return this.authme.asObservable();
  }

  setLoggedInuserDetails(value) {
    this.authme.next(value);
  }
}

